<template>
  <div class="listContainer" @keyup.enter="onSearch">
    <!-- 面包屑 -->
    <a-breadcrumb class="breadcrumb">
      <span slot="separator">></span>
      <a-breadcrumb-item>工单管理</a-breadcrumb-item>
      <a-breadcrumb-item>
        <a>缺货补货表</a>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <!-- 面包屑 end   -->
    <!-- 增加&搜索 -->
    <section>
      <section class="searchBox">
        <span>
          <label>项目：</label>
          <a-select
            v-model="project_id"
            style="width:180px"
            showSearch
            :filterOption="filterOption"
            optionFilterProp="children"
            placeholder="请选择项目"
          >
            <a-select-option
              v-for="(item, i) in proList"
              :key="i"
              :value="item.id"
              >{{ item.project_name }}
            </a-select-option>
          </a-select>
        </span>
        <span>
          <label>状态：</label>
          <!-- 状态：默认0 10未完成 20 完成 30 已取消 -->
          <a-radio-group v-model="status">
            <a-radio :value="10">未完成</a-radio>
            <a-radio :value="20">已完成</a-radio>
            <a-radio :value="30">已取消</a-radio>
          </a-radio-group>
        </span>
        <span>
          <label>字符串：</label>
          <a-input
            placeholder="请输入网点名称|项目名称"
            style="width:200px"
            v-model="query_field"
          />
        </span>
        <span>
          <a-button class="resetStyle" @click="downloadData">
            <a-icon type="vertical-align-bottom" />下载
          </a-button>
          <a-button @click="onReset">重置</a-button>
          <a-button type="primary" icon="search" @click="onSearch"
            >搜索</a-button
          >
        </span>
      </section>
      <!-- 增加&搜索 end-->
      <section class="tableStyles">
        <a-table
          :data-source="tableList"
          :scroll="{ x: 1500 }"
          :pagination="false"
          :columns="columns"
          :rowKey="reord => reord.id"
        >
          <span slot="firm_id" slot-scope="item">
            <span v-show="item.firm_id == 1">易触</span>
            <span v-show="item.firm_id == 2">华屹1</span>
            <span v-show="item.firm_id == 3">华屹2</span>
            <span v-show="item.firm_id == 4">卡游</span>
          </span>
          <span slot="status" slot-scope="item">
            <span v-show="item.status == 10">未完成</span>
            <span v-show="item.status == 20">已完成</span>
            <span v-show="item.status == 30">已取消</span>
          </span>
          <span slot="action" slot-scope="item">
            <span class="btn ant-dropdown-link" @click="cancelChange(item)">
              <a v-if="item.status == 10">取消</a>
            </span>
          </span>
        </a-table>
      </section>
      <div class="paginationStyle" :loading="loading">
        <a-pagination
          showQuickJumper
          :defaultCurrent="page"
          :total="pagination.total"
          @change="onChange"
          :current="page"
        />
        <span>{{ "共：" + pagination.total + "条" }}</span>
      </div>
    </section>
    <!-- content end -->
    <a-modal
      v-model="visiblecancel"
      title="取消补货"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOkcancel"
    >
      <a-textarea
        v-model="cancel"
        placeholder="请输入取消原因"
        :auto-size="{ minRows: 3, maxRows: 5 }"
      />
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
const columns = [
  {
    title: "项目名称",
    dataIndex: "project_name",
    fixed: "left",
    width: 150
  },
  {
    title: "网点名称",
    dataIndex: "device_name",
    width: 200
  },
  {
    title: "设备厂商",
    slots: { title: "firm_id" },
    scopedSlots: { customRender: "firm_id" },
    width: 120
  },
  {
    title: "设备编号",
    dataIndex: "device_unique_id",
    width: 250
  },
  {
    title: "缺货时间",
    dataIndex: "need_add_time",
    align: "right",
    width: 200
  },
  {
    title: "管家姓名",
    dataIndex: "guard_name",
    align: "center",
    width: 120
  },
  {
    title: "原因",
    dataIndex: "reason",
    width: 250
  },
  {
    title: "工单时间",
    dataIndex: "finish_time",
    align: "right",
    width: 200
  },
  {
    title: "差异",
    dataIndex: "diff_time",
    align: "right",
    width: 150
  },
  {
    title: "取消原因",
    dataIndex: "cancel",
    width: 250
  },
  {
    title: "状态",
    slots: { title: "status" },
    scopedSlots: { customRender: "status" },
    width: 100
  },
  {
    title: "操作", //"详情",
    slots: { title: "actionTitle" },
    scopedSlots: { customRender: "action" },
    width: 100
  }
];
export default {
  data() {
    return {
      moment,
      data: [],
      loading: false,
      page: 1,
      pagination: {},
      thList: [
        "项目名称",
        "网点名称",
        "设备厂商",
        "设备编号",
        "缺货时间",
        "管家姓名",
        "原因",
        "工单时间",
        "差异",
        "状态"
      ],
      tableList: [],
      columns,
      visiblecancel: false,
      showId: "",
      cancel: "",
      query_field: "",
      project_id: "",
      status: "",
      date: null,
      proList: []
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  components: {},
  mounted() {
    this.getPro(); //获取项目
    this.getData(); //获取列表
  },
  methods: {
    cancelChange(item) {
      this.visiblecancel = true;
      this.showId = item.id;
    },
    handleOkcancel() {
      this.visiblecancel = false;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device/needAddCancel";
      axios
        .post(url, {
          cancel: this.cancel,
          id: this.showId,
          token: window.localStorage.getItem("xnwfPcToken")
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.getData();
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    downloadData() {
      window.location.href =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Device/needAddDownload?token=" +
        window.localStorage.getItem("xnwfPcToken") +
        "&query_field=" +
        this.query_field +
        "&project_id=" +
        this.project_id +
        "&status=" +
        this.status;
    },
    getPro() {
      let url =
        this.httpsBasic.url + this.httpsBasic.trade + "Project/projectList";
      axios
        .post(url, {
          current_page: 1,
          per_page: 10000,
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 2
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data.data;
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    },
    onChange(pageNumber) {
      this.page = pageNumber;
      this.getData();
    },
    onSearch() {
      this.page = 1;
      this.getData();
    },
    reload() {
      this.$nextTick(function() {
        this.getData();
      });
    },
    onReset() {
      this.date = null;
      this.status = "";
      this.project_id = "";
      this.query_field = "";
      this.page = 1;
      this.getData();
    },
    getData() {
      // console.log(this.$store.state.token);
      this.loading = true;
      let url =
        this.httpsBasic.url + this.httpsBasic.equipment + "Device/needAdd";
      let params = {
        current_page: this.page,
        per_page: 10,
        query_field: this.query_field,
        project_id: this.project_id,
        status: this.status,
        token: window.localStorage.getItem("xnwfPcToken")
      };
      axios
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            this.data = res.data.data.data;
            this.tableList = res.data.data.data;
            // console.log(this.data);
            this.loading = false;
            const pagination = { ...this.pagination };
            pagination.total = res.data.data.total;
            this.pagination = pagination;
          } else {
            this.$message.warning(res.data.message);
            this.loading = false;
          }
        })
        .catch(err => {
          this.$message.error("服务器出错啦...");
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
@import url(../../style/listBasic.less);

.listContainer {
  td {
    img {
      height: 30px;
      width: 30px;
      object-fit: cover;
    }
  }
}
</style>
